import React from "react";
import {Edit} from "react-admin";
import NoopComponent from "common/noop-component/NoopComponent";
import UGroupForm from "./UGroupForm";

export default (props) => {
  return <Edit {...props} title={<NoopComponent/>} hasShow={false}>
    <UGroupForm action='edit'/>
  </Edit>
};